module.exports = __webpack_public_path__ + "static/media/icon-historical_data.d72b9b47.svg";